import { render, staticRenderFns } from "./IntermediarySettings.vue?vue&type=template&id=d16d419a"
import script from "./IntermediarySettings.vue?vue&type=script&lang=js"
export * from "./IntermediarySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports